import Modifier from 'ember-modifier';
import { registerDestructor } from '@ember/destroyable';
import { service } from '@ember/service';

function cleanup(instance) {
  let { element, event, handler } = instance;

  if (element && event && handler) {
    element.removeEventListener(event, handler);

    instance.element = null;
    instance.event = null;
    instance.handler = null;
  }
}

export default class TrackEventInitiativesInteractionModifier extends Modifier {
  @service tracker;

  element = null;
  event = null;
  handler = null;

  modify(element, [event, id = undefined]) {
    const handler = () =>
      this.tracker.trackInitiativesTableInteractionEvent(id);
    this.addEventListener(element, event, handler);
    registerDestructor(this, cleanup);
  }

  // methods for reuse
  addEventListener(element, event, handler) {
    // Store the current element, event, and handler for when we need to remove
    // them during cleanup.
    this.element = element;
    this.event = event;
    this.handler = handler;

    element.addEventListener(event, handler);
  }
}
